import { Link, useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';

import { fetchStockTransferDetail } from '#/api/imsMgmt/receipts/stockTransfer/fetchDetail';
import { fetchWorkOrderStockTransferDetail } from '#/api/momMgmt/workOrder/transfer/fetchDetail';
import { Button } from '#/modules/commonComponents/button';
import { cn } from '#/lib/utils';
import PageShell from '#/modules/infra/layout/PageShell';
import StockTransferBlock from '#/modules/imsMgmt/receipts/stockTransfer/components/StockTransferBlock';
import { getStockTransferApiErrorMessage } from '#/modules/imsMgmt/receipts/stockTransfer/helper/apiError';
import { useStockTransferEntryRoutes } from '#/modules/imsMgmt/receipts/stockTransfer/helper/stockTransferEntryRoutes';
import {
  stockTransferDetailQueryKey,
  workOrderStockTransferDetailQueryKey,
} from '#/utils/queryKeys';

const StockTransferDetailPage = () => {
  const { id } = useParams();
  const transferRoutes = useStockTransferEntryRoutes();
  const isWorkOrderTransfer = transferRoutes.isWorkOrderTransfer;
  const detailQueryKey = isWorkOrderTransfer
    ? workOrderStockTransferDetailQueryKey
    : stockTransferDetailQueryKey;

  const detailQuery = useQuery({
    queryKey: detailQueryKey(id),
    queryFn: () => (
      isWorkOrderTransfer
        ? fetchWorkOrderStockTransferDetail(id)
        : fetchStockTransferDetail(id)
    ),
    enabled: Boolean(id),
  });

  const detail = detailQuery.data?.data;
  const isLoading = detailQuery.isLoading;
  const isError = detailQuery.isError;

  return (
    <PageShell variant="detail">
      <div className="layout-shell__body">
        <div className="w-full space-y-4">
          <div
            className={cn(
              'sticky top-0 z-20 -mx-1 flex flex-wrap items-center gap-2',
              'border-b border-slate-200 bg-canvas px-1 pb-3 pt-1',
            )}
          >
            <h1 className="page_title mb-0!">
              <span className="border-l-5 border-primary-400 pl-2.5">轉倉單詳情</span>
            </h1>
            <Button type="button" variant="outline" asChild>
              <Link to={transferRoutes.list}>返回列表</Link>
            </Button>
          </div>

          {isLoading ? (
            <p className="text-sm text-slate-500">載入中…</p>
          ) : null}

          {isError ? (
            <p className="text-sm text-destructive">
              {getStockTransferApiErrorMessage(detailQuery.error, '載入轉倉單失敗')}
            </p>
          ) : null}

          {detail ? (
            <StockTransferBlock
              detail={detail}
              defaultOpen
              showActions
              splitFullWidthDetail={isWorkOrderTransfer}
              onRefetch={() => detailQuery.refetch()}
            />
          ) : null}
        </div>
      </div>
    </PageShell>
  );
};

export default StockTransferDetailPage;
